<script>
import AdminLayout from '@layouts/admin-main'
import date from 'locutus/php/datetime/date'
import CsTicketTypeInfo from '@components/admin/cs-ticket-type-info'
import CsFaqTypeInfo from '@components/admin/cs-faq-type-info'
import {
  fetchTicketTypes,
  deleteTicketType,
  fetchFaqTypes,
  deleteFaqType,
} from '@apis/admin/cs'

export default {
  page: {
    title: 'ConfigCs',
    meta: [{ name: 'description', content: 'ConfigCs' }],
  },
  components: { AdminLayout, CsTicketTypeInfo, CsFaqTypeInfo },
  data() {
    return {
      ticket_types: [],
      show_ticket_type_info: false,
      target_ticket_type_seq: 0,
      faq_types: null,
      show_faq_type_info: false,
      target_faq_type_seq: 0,
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    date,
    init() {
      Promise.all([this.loadTicketTypes(), this.loadFaqTypes()]).catch((e) =>
        this.$toasted.error(e.message)
      )
    },
    async loadTicketTypes() {
      const { data } = await fetchTicketTypes()
      this.ticket_types = data
    },
    handleCreateTicketType() {
      this.show_ticket_type_info = true
      this.target_ticket_type_seq = null
    },
    handleUpdateTicketType({ seq }) {
      this.show_ticket_type_info = true
      this.target_ticket_type_seq = seq
    },
    handleTicketTypeSubmit(seq) {
      this.init()
      this.target_ticket_type_seq = seq
    },
    async handleDeleteTicketType(seq) {
      try {
        if (
          !(await this.$confirm(
            this.$t('admin.confirm_delete'),
            this.$t('admin.modal_confirm'),
            {
              type: 'warning',
            }
          ).catch(() => false))
        )
          return

        await deleteTicketType(seq)
        await this.loadTicketTypes()
      } catch (e) {
        this.$toasted.error(e.message)
      }
    },
    async loadFaqTypes() {
      const { data } = await fetchFaqTypes()
      this.faq_types = data
    },
    handleCreateFaqType() {
      this.show_faq_type_info = true
      this.target_faq_type_seq = null
    },
    handleUpdateFaqType({ seq }) {
      this.show_faq_type_info = true
      this.target_faq_type_seq = seq
    },
    handleFaqTypeSubmit(seq) {
      this.init()
      this.target_faq_type_seq = seq
    },
    async handleDeleteFaqType(seq) {
      try {
        if (
          !(await this.$confirm(
            this.$t('admin.confirm_delete'),
            this.$t('admin.modal_confirm'),
            {
              type: 'warning',
            }
          ).catch(() => false))
        )
          return

        await deleteFaqType(seq)
        await this.loadFaqTypes()
      } catch (e) {
        this.$toasted.error(e.message)
      }
    },
  },
}
</script>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';
</style>

<template>
  <AdminLayout>
    <div :class="$style.adminLeftContent">
      <h3 :class="$style.xeAdmin">{{
        $t('config_cs.type_of_cs_statement')
      }}</h3>
      <table cellspacing="0" cellpadding="0" :class="$style.crossTable">
        <thead>
          <tr>
            <th scope="col"
              ><div>{{ $t('admin.form_info_list_order') }}</div></th
            >
            <th scope="col"
              ><div>{{ $t('admin.user_name') }}</div></th
            >
            <th scope="col"
              ><div>{{ $t('admin.title') }}</div></th
            >

            <th scope="col"
              ><div>{{ $t('admin.regdate') }}</div></th
            >
            <th scope="col">
              <div :class="$style.tRight">
                <a
                  href="#"
                  :class="[$style.button, $style.black]"
                  @click.prevent="handleCreateTicketType"
                  ><span>{{ $t('admin.add') }}</span></a
                >
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="type in ticket_types" :key="type.seq">
            <td :class="[$style.tCenter, $style.nowrap]">{{
              type.list_order
            }}</td>
            <td :class="[$style.tCenter, $style.nowrap]">{{ type.name }}</td>
            <td :class="[$style.wide]">{{ type.title }}</td>

            <td :class="[$style.tCenter, $style.nowrap]">{{
              date('Y-m-d H:i:s', new Date(type.regdate))
            }}</td>
            <td :class="[$style.tRight, $style.nowrap]">
              <a
                href="#"
                :class="[$style.button]"
                @click.prevent="handleUpdateTicketType(type)"
                ><span>{{ $t('admin.modify') }}</span></a
              >
              {{ ' ' }}
              <a
                href="#"
                :class="[$style.button, $style.red]"
                @click.prevent="handleDeleteTicketType(type.seq)"
                ><span>{{ $t('admin.delete') }}</span></a
              >
            </td>
          </tr>
          <tr v-if="!ticket_types.length">
            <td :colspan="5" :class="$style.tCenter">{{
              $t('config_cs.msg_no_cs_statement')
            }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div :class="$style.adminRightExtra">
      <h3 :class="$style.xeAdmin">{{ $t('config_cs.cs_faq_type') }}</h3>
      <table cellspacing="0" cellpadding="0" :class="$style.crossTable">
        <thead>
          <tr>
            <th scope="col"
              ><div>{{ $t('config_cs.type_name') }}</div></th
            >
            <th scope="col"
              ><div>{{ $t('config_cs.type_namea') }}</div></th
            >

            <th scope="col"
              ><div>{{ $t('admin.regdate') }}</div></th
            >
            <th scope="col">
              <div :class="$style.tRight">
                <a
                  href="#"
                  :class="[$style.button, $style.black]"
                  @click.prevent="handleCreateFaqType"
                  ><span>{{ $t('admin.add') }}</span></a
                >
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="type in faq_types" :key="type.seq">
            <td :class="[$style.tCenter, $style.nowrap]">{{ type.name }}</td>
            <td :class="[$style.wide]">{{ type.title }}</td>

            <td :class="[$style.tCenter, $style.nowrap]">{{
              date('Y-m-d H:i:s', new Date(type.regdate))
            }}</td>
            <td :class="[$style.tRight, $style.nowrap]">
              <a
                href="#"
                :class="[$style.button]"
                @click.prevent="handleUpdateFaqType(type)"
                ><span>{{ $t('admin.modify') }}</span></a
              >
              {{ ' ' }}
              <a
                href="#"
                :class="[$style.button, $style.red]"
                @click.prevent="handleDeleteFaqType(type.seq)"
                ><span>{{ $t('admin.delete') }}</span></a
              >
            </td>
          </tr>
          <tr v-if="!faq_types">
            <td :colspan="5" :class="$style.tCenter">{{
              $t('config_cs.msg_no_cs_faq')
            }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <ElDialog
      :title="
        target_ticket_type_seq
          ? $t('config_cs.modify')
          : $t('config_cs.registration')
      "
      :visible.sync="show_ticket_type_info"
      width="1240px"
    >
      <CsTicketTypeInfo
        v-if="show_ticket_type_info"
        :key="target_ticket_type_seq"
        :type_seq="target_ticket_type_seq"
        @submit="handleTicketTypeSubmit"
      ></CsTicketTypeInfo>
    </ElDialog>
    <ElDialog
      :title="
        target_faq_type_seq
          ? $t('config_cs.faq_modify')
          : $t('config_cs.faq_registration')
      "
      :visible.sync="show_faq_type_info"
      width="1240px"
    >
      <CsFaqTypeInfo
        v-if="show_faq_type_info"
        :key="target_faq_type_seq"
        :type_seq="target_faq_type_seq"
        @submit="handleFaqTypeSubmit"
      ></CsFaqTypeInfo>
    </ElDialog>
  </AdminLayout>
</template>
